import React, { useState } from 'react';

import { SnackbarView } from '~/src/dash/views/snackbar-view';

// How to use me?
//      const snackbarV2 = new SnackbarV2();
// in the render func:
//      { snackbarV2.component() }
// To display a message:
// - message:
//      snackbarV2.displayMessage('Successfully saved monitor!');
// - error:
//      snackbarV2.displayMessage(err, true);

export class SnackbarV2 {
  private readonly msg: string;
  private readonly setMsg: any;
  private readonly err: boolean;
  private readonly setErr: any;

  constructor() {
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarError, setSnackbarError] = useState(false);

    this.msg = snackbarMessage;
    this.setMsg = setSnackbarMessage;
    this.err = snackbarError;
    this.setErr = setSnackbarError;
  }

  public displayMessage(message: string, isError: boolean = false) {
    this.setMsg(message);
    this.setErr(isError);
  }

  public component(): JSX.Element {
    return (
      <SnackbarView
        open={!!this.msg}
        error={!!this.err}
        onClose={() => {
          this.setMsg('');
          this.setErr(false);
        }}
      >
        {this.msg}
      </SnackbarView>
    );
  }
}
